<div>
  <h1 mat-dialog-title>Customize Cartesian Grid</h1>

  <div class="container dialog-content" mat-dialog-content>
    <div class="item-config-single">
      <div class="item-config-group">
        <label class="item-config-label" for="xPos">x (cm) : </label>
        <input
          type="number"
          placeholder="Origin X"
          [value]="cartesianPos.x / 10 | number: '1.2-2'"
          class="form-control"
          name="xPos"
          id="xPos"
          #xPos
        />
      </div>

      <div class="item-config-group">
        <label class="item-config-label" for="yPos">y (cm) : </label>
        <input
          type="number"
          placeholder="Origin Y"
          [value]="cartesianPos.y / 10 | number: '1.2-2'"
          class="form-control"
          name="yPos"
          id="yPos"
          #yPos
        />
      </div>

      <div class="item-config-group">
        <label class="item-config-label" for="zPos">z (cm) : </label>
        <input
          type="number"
          placeholder="Origin Z"
          [value]="cartesianPos.z / 10 | number: '1.2-2'"
          class="form-control"
          name="zPos"
          id="zPos"
          #zPos
        />
      </div>

      <button
        mat-stroked-button
        (click)="onSave(xPos.value, yPos.value, zPos.value)"
        [disabled]="shiftGrid"
      >
        Save
      </button>

      <button
        style="margin: 0.5rem 0"
        mat-menu-item
        class="explain-button"
        [disabled]="shiftGrid"
        (click)="$event.stopPropagation(); shiftCartesianGridByPointer()"
      >
        Shift Cartesian Grid on click
        <p class="explain-text">
          Click on a point to shift the grid. Keep clicking at various points to
          continue shifting. Right click to stop.
        </p>
      </button>
    </div>

    <div>
      <button
        mat-menu-item
        (click)="showXYPlanesCheckbox._inputElement.nativeElement.click()"
      >
        <mat-checkbox
          #showXYPlanesCheckbox
          [(ngModel)]="gridConfig.showXY"
          (click)="$event.stopPropagation()"
          (change)="showXYPlanes($event)"
          >Show XY Planes
        </mat-checkbox>
      </button>
      <button class="slider-btn" mat-menu-item (focus)="xyPlaneSlider.focus()">
        <mat-slider min="-300" [max]="scale" step="300" thumbLabel>
          <input
            #xyPlaneSlider
            matSliderThumb
            [value]="gridConfig.zDistance"
            (input)="addXYPlanes($event)"
          />
        </mat-slider>
        XY Plane ({{ calcPlanes(gridConfig.zDistance) }})
      </button>
      <button
        mat-menu-item
        (click)="showYZPlanesCheckbox._inputElement.nativeElement.click()"
      >
        <mat-checkbox
          #showYZPlanesCheckbox
          [(ngModel)]="gridConfig.showYZ"
          (click)="$event.stopPropagation()"
          (change)="showYZPlanes($event)"
          >Show YZ Planes
        </mat-checkbox>
      </button>
      <button class="slider-btn" mat-menu-item (focus)="yzPlaneSlider.focus()">
        <mat-slider min="-300" [max]="scale" step="300" thumbLabel>
          <input
            #yzPlaneSlider
            matSliderThumb
            [value]="gridConfig.xDistance"
            (input)="addYZPlanes($event)"
          />
        </mat-slider>
        YZ Plane ({{ calcPlanes(gridConfig.xDistance) }})
      </button>
      <button
        mat-menu-item
        (click)="showZXPlanesCheckbox._inputElement.nativeElement.click()"
      >
        <mat-checkbox
          #showZXPlanesCheckbox
          [(ngModel)]="gridConfig.showZX"
          (click)="$event.stopPropagation()"
          (change)="showZXPlanes($event)"
          >Show ZX Planes
        </mat-checkbox>
      </button>
      <button class="slider-btn" mat-menu-item (focus)="zxPlaneSlider.focus()">
        <mat-slider min="-300" [max]="scale" step="300" thumbLabel>
          <input
            #zxPlaneSlider
            matSliderThumb
            [value]="gridConfig.yDistance"
            (input)="addZXPlanes($event)"
          />
        </mat-slider>
        ZX Plane ({{ calcPlanes(gridConfig.yDistance) }})
      </button>
      <button class="slider-btn" mat-menu-item (focus)="sparsitySlider.focus()">
        <mat-slider min="1" max="5" step="1" thumbLabel>
          <input
            #sparsitySlider
            matSliderThumb
            [value]="gridConfig.sparsity"
            (input)="changeSparsity($event)"
          />
        </mat-slider>
        Sparsity ({{ gridConfig.sparsity }})
      </button>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onClose()" cdkFocusInitial>
      Close
    </button>
  </div>
</div>
